var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 988.4 1136.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 11px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n        stroke: #757575;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 10.53px;\n      }\n\n      .cls-3 {\n        stroke-width: 8px;\n      }\n\n      .cls-4 {\n        stroke-width: 12px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounce"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M620.37,836.83c196.97,13.83,345.14,73.61,345.14,145.26,0,81.89-193.53,148.27-432.25,148.27s-432.25-66.38-432.25-148.27c0-70.42,143.12-129.38,335.03-144.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M564.43,924.92c77.51,5.44,133.82,28.97,133.82,57.16,0,32.23-76.16,58.35-170.1,58.35s-170.1-26.12-170.1-58.35c0-27.64,56.04-50.8,131.27-56.82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "481.96 720.54 483.08 796.98 411.36 796.98 528.15 989.16 647.37 796.98 580.21 796.98 580.21 719.62"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Pickleball"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 528.15,
    cy: 455.17,
    rx: 264.92,
    ry: 267.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 668.14,
    cy: 320.86,
    rx: 14.96,
    ry: 25,
    transform: "translate(-31.19 566.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M702.61,452.13c0-13.81,8.22-25,18.36-25s18.36,11.19,18.36,25c0,13.81-8.22,25-18.36,25-10.14,0-18.36-11.19-18.36-25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 654.91,
    cy: 598.63,
    rx: 25,
    ry: 15.76,
    transform: "translate(-231.8 566.82) rotate(-40.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 520.06,
    cy: 654.28,
    rx: 15.76,
    ry: 25,
    transform: "translate(-204.39 1071.08) rotate(-81.43)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 371.02,
    cy: 586.67,
    rx: 15.76,
    ry: 25,
    transform: "translate(-281.72 350.51) rotate(-37.8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 441.31,
    cy: 520.47,
    rx: 24.48,
    ry: 25,
    transform: "translate(-168.34 827.02) rotate(-76.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 587.21,
    cy: 529.77,
    rx: 27.46,
    ry: 22.89,
    transform: "translate(-115.04 893.51) rotate(-69.44)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 318.21,
    cy: 451.53,
    rx: 16.28,
    ry: 25.76,
    transform: "translate(-25.02 18.71) rotate(-3.24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 446.27,
    cy: 373.18,
    rx: 25.32,
    ry: 23.85,
    transform: "translate(-41.94 56.84) rotate(-6.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 384.7,
    cy: 304.04,
    rx: 25.32,
    ry: 17.44,
    transform: "translate(-98.07 389.91) rotate(-48.41)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 519.31,
    cy: 248.62,
    rx: 25.32,
    ry: 17.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 591.78,
    cy: 385.62,
    rx: 25.32,
    ry: 24.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M762.25,579.32c-8.59-11.21-4.86-29.32-2.8-35.3,4.42-10.37,14.19-20.54,22.23-19.24,11.95,1.31-19.42,54.54-19.42,54.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M782.78,392.38c-6.76,0-15.63-10.91-18.64-15.94s-8.57-20.47-.6-36.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M619.66,203.48s6.47,21.52,23.91,27.06c12.38,3,18.89,4.83,22.66.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M593.62,715.05c.33-5.74,4.28-14.17,13.03-20.24,8.58-5.82,26.25-6.87,31.04-5.2s9.68,6.11,9.68,6.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShots);
export default __webpack_public_path__ + "static/media/shots.9d9898f36b5d3610aa275e05f36bcbfc.svg";
export { ForwardRef as ReactComponent };